import * as format from '../data/format';
import moment from 'moment'; 
import { TRANSPARENT } from '../data/constants';


export function preRender(data, options) {
  const tooltip = data.tooltip = { enabled: options.interactive };
  if (tooltip.enabled) {
    tooltip.borderWidth = 1;
    tooltip.borderColor = '#CCC';
    tooltip.shared = false;
    tooltip.style = getStyle(options);
    
    tooltip.shadow = false;
    tooltip.formatter = function () {
      return formatter(data, options, this);
    };
  }

  if (__WSJ__) {
    if (options.product === 'wsj') {
      tooltip.borderRadius = 0;
      tooltip.padding = 5;
    }
  }
  return data;
}

function formatter(data, options, context) {
  // hide tooltip for transparent data
  if (context.color === TRANSPARENT) return false;
  const value = format.applyFull(context.point.y, options.tooltips, options.type === 'pie', true, true);
  const categories = options.longCategories || (options.categories ?
    options.categories[0] : null);
  let firstYear = categories[0];
  let lastYear = categories[categories.length - 1];
  let isReverse = false;
  if (typeof firstYear === 'string' && typeof lastYear === 'string' && options.categoriesAreDates) {
    let firstYearSplit = firstYear.split(' ');
    let lastYearSplit = lastYear.split(' ');
    if (firstYearSplit.indexOf('p.m.') !== -1 && firstYearSplit.indexOf('a.m.') !== -1) {
      let firstYearTime = firstYearSplit[firstYearSplit.length - 2];
      let firstYearTimeSplit = firstYearTime.split(':')
      let hourFirstTimeSplit = parseInt(firstYearTimeSplit) + 12;
      hourFirstTimeSplit = hourFirstTimeSplit.toString();
      firstYearTimeSplit[0] = hourFirstTimeSplit;
      firstYearTimeSplit = firstYearTimeSplit.join(':');
      let lastYearTime = lastYearSplit[lastYearSplit.length - 2];
      let lastYearTimeSplit = lastYearTime.split(':')
      let hourLastTimeSplit = parseInt(lastYearTimeSplit) + 12;
      hourLastTimeSplit = hourLastTimeSplit.toString();
      lastYearTimeSplit[0] = hourLastTimeSplit;
      lastYearTimeSplit = lastYearTimeSplit.join(':');

      isReverse = firstYearTimeSplit > lastYearTimeSplit;
    } else {
      isReverse = findIfReverse(categories)
    }
  }
  
  if (isReverse) {
    categories.reverse();
  }
  const seriesData = !data.series ? options.series : data.series;
  const dataPoint = getDataPoint(seriesData, context, isReverse);
  let category;
  if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
    category = context.point.name
  } else {
    category = categories ? categories[dataPoint.index] : (context.point.category ||
      context.point.options.name);
  }
  // console.log(context.point);
  // if (categories) {
  //   if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
  //     category = categories[dataPoint.point.originalIndex];
  //   } else {
  //     category = categories[dataPoint.index];
  //   }
  // } else {
  //   category = context.point.category || context.point.options.name;
  // }
  const formatter = { index: dataPoint.index, category, value };

  if ((options.type === 'column' || options.type === 'area')
      && options.stacking === 'percent') {
    return formatStackedPercent(data, options, context, formatter);
  }
  return formatStandard(options, context, formatter);
}

function findIfReverse(categories) {
  let currentDateComparison = categories[0]
  for (let f = 1; f < categories.length; f++) {
    if (isNaN(new Date(categories[f]))) {
      return false;
    }
    if (f === 1) {
      if (Date.parse(currentDateComparison) < Date.parse(categories[f])) {
        return false;
      }
    } else {
      currentDateComparison = categories[f - 1];
      if (Date.parse(currentDateComparison) < Date.parse(categories[f])) {
        return false;
      }
      if (f === categories.length - 1 && Date.parse(currentDateComparison) > Date.parse(categories[f])) {
        return true;
      }
      
    }
  }
}

function getDataPoint(series, context, isReverse) {
  if (context.x !== undefined) {
    for (let s = 0; s < series.length; s++) {
      for (let d = 0; d < series[s].data.length; d++) {
        if (series[s].data[d].x === context.x) {
          return { point: series[s].data[d], index: series[s].data[d].index };
        }
      }
    }
  }
  return {
    point: context.point,
    index: context.point.hasOwnProperty('index') ? context.point.index :
      context.point.x
  };
}


function divideValue(value, divisorUnit) {
  if (divisorUnit && divisorUnit !== 'none') {
    const divisor = format.getDivisor(divisorUnit);
    return +value / divisor;
  }
  return value;
}

function space() {
  return '<span style="color: rgba(255, 255, 255, 0);">x</span>';
}


function formatStandard(options, context, formatter) {
  const isWSJWeight = options.product === 'wsj' ? 500 : 600;
  return [
    '<span>',
      formatSeries(options, context),
      '<span>',
        formatter.category,
      '</span>',
      space(),
      `<span style="font-weight: ${isWSJWeight};">`,
        formatter.value,
      '</span>',
    '</span>'
  ].join('');
}


function formatStackedPercent(data, options, context, formatter) {
  const isWSJWeight = options.product === 'wsj' ? 500 : 600;
  let total = 0;
  data.series.forEach(item => {
    total += item.data[formatter.index].y;
  });
  return [
    '<span style="',
    formatter.style,
    '">',
      formatSeries(options, context),
      '<span style="padding: 0 6px 0 0;">',
        formatter.category,
      '</span>',
      space(),
      `<span style="font-weight: ${isWSJWeight}; margin: 0 0 0 24px">`,
        formatter.value,
        ' (',
        Math.round(context.point.y / total * 100),
        '%)',
      '</span>',
    '</span>'
  ].join('');
}



function formatSeries(options, context) {
  if (options.legend.enabled && options.series.length > 1) {
    let css;
    let defaultCSS = [
      'padding: 0 6px 0 0;',
    ];

    if (options.product !== 'wsj') {
      css = defaultCSS.concat([
        'font-weight: 600;',
        `color: ${context.series.color};`
      ]).join('');
    }

    if (options.product === 'wsj') {
      css = defaultCSS.concat([
        'font-weight: 500;'
      ]).join('');
    }
    let nameArray = context.series.name.toString().split(' ');
    if (nameArray[0] === '<br') {
      for (let i = 0; i < nameArray.length; i++) {
        if (nameArray[i] === '<br' || nameArray[i] === '/>') {
          nameArray.splice(i, 1);
          i--
        }
      }
    }
    nameArray = nameArray.join(' ');
    return [
      `<span style="${css}">`,
      nameArray,
      '</span>',
      space()
    ].join('');
  }
}


function getStyle(options) {
  let data = {
    padding: '8px',
    width: '400px',
    fontSize: '14px',
    fontFamily: options.styles.font.normal,
    fontWeight: options.styles.weight.normal,
    fontStyle: 'normal',
    color: '#000000',
  };

  if (__WSJ__) {
    if (options.product === 'wsj') {
      data.fontSize = '15px';
      data.lineHeight = '18px';
      data.fontWeight = 300;
    }
  }

  return data;
}



export function postRender(highchart, options) {
  
}



// WEBPACK FOOTER //
// ./src/chart/inner/tooltips.js